import * as types from './types';

export const fetchAll = (subId) => ({
  type: types.FETCH_ALL,
  payload: { subId }
});

export const find = (id) => ({
  type: types.FIND,
  payload: { id }
});

export const findUpcoming = (subId) => ({
  type: types.FIND_UPCOMING,
  payload: { subId }
});

export const findUpcomingFailed = (subId, err) => ({
  type: types.FIND_UPCOMING_FAILED,
  payload: { subId, err }
});
